import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Login.css";
import Axios from "../utils/Axios";
import validateForm from "../utils/Validation";
import socket from "../utils/Socket";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN_REQUEST } from "../store/Actions/Actions";
import BackgroundBubbles from "./BackgroundBubbles.jsx";

function Login() {
  

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const errorMsg = useSelector((state) => state.login.error);
  const isLoading = useSelector((state) => state.login.isLoading);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formErrors, setFormErrors] = useState({});
  const [hide,setHide]=useState(true)

  useEffect(() => {
    socket.on("notification", (data) => {
      alert("New notification received: " + data.title);
    });
    return () => socket.off("notification");
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setHide(false)
    const payload = { username, password };
    const requiredFields = ["username", "password"];
    const errors = validateForm(payload, requiredFields);
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    dispatch({ type: LOGIN_REQUEST, payload });
  };

  return (
    <div className="login-page container-fluid vh-100 overflow-hidden">
      <div className="row h-100 g-0">
        {/* Left */}
        <div className="col-lg-7 d-none   d-lg-flex flex-column justify-content-center align-items-center bg-dual-blue text-white text-center px-4" style={{ position: "relative", overflow: "hidden" }}>
          <BackgroundBubbles color="rgba(31, 182, 201, 0.12)" /> 
      {/* Try rgba(43, 78, 162, 0.12) for deeper blue, or tweak maxBubbles */}
          <h1 className="mb-4 fw-lighter  fade-in">Let’s Get Things Done!</h1>
          <div style={{ height: "200px " }}></div>
          <p className="inter-lead fw-lighter fs-3 fade-in-subtitle">
            Manage your work, tasks and timesheets all in one place.
          </p>
        </div>

        {/* Right */}
        <div className="col-lg-5 d-flex justify-content-center align-items-center bg-white position-relative">
          <div className="w-75" style={{ maxWidth: 400 }}>
            <div className="w-100 d-flex justify-content-center">
              <img
                src="../assets/images/logo.png"
                style={{ width: "55%", paddingTop: "5%", paddingBottom: "6%" }}
              ></img>
            </div>
            <h2 className="mb-3 text-center fw-lighter text-body-secondary fw-">
              Sign In
            </h2>
            <h6
              className="mb-4 text-center fw-lighter text-body-secondary fw-"
              
            >
              Enter your valid credentials to sign in{" "}
            </h6>

            <form onSubmit={handleLogin} style={{ marginTop: "5%"  }}>
              <div className="mb-3">
                <div
                  className={`form-group flex-item ${
                    formErrors.username ? "has-error" : ""
                  }`}
                >
                  <label htmlFor="username" className="form-label fw-lighter">
                    Email address
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="username"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <div className="mb-3">
                <div
                  className={`form-group flex-item ${
                    formErrors.password ? "has-error" : ""
                  }`}
                >
                  <div className="d-flex justify-content-end mb-2">
                    <Link
                      className="mb-0 d-inline-block mt-2 mb-2 small"
                      to="/forgot-password"
                    >
                      Forgot Password?
                    </Link>
                  </div>

                  <div className="input-group flat-border">
                    <input
                      className="form-control border-0"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                    />
                    <span
                      className="input-group-text bg-white border-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword((s) => !s)}
                    >
                      {showPassword ? (
                        <i className="bi bi-eye-slash" />
                      ) : (
                        <i className="bi bi-eye" />
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="form-check m-0">
                    <input
                      className="form-check-input remember-input"
                      type="checkbox"
                      id="rememberMe"
                    />
                    <label
                      className="form-check-label remember-label ms-2"
                      htmlFor="rememberMe"
                    >
                      Remember me
                    </label>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary w-100 mt-2">
                Login
              </button>

              {isLoading && (
                <div className="loading-login">
                  <img
                    className="loading-login-img"
                    src="/assets/images/l2.gif"
                    alt="Loading"
                  />
                </div>
              )}

              {errorMsg && (
                <div className="alert mt-3" role="alert">
                  {errorMsg}
                </div>
              )}
            </form>
           {hide &&( <div className="d-flex justify-content-center align-items-center border-1 mt-5 ">
              <span className="login-footer m-0 pt-2">
                © {new Date().getFullYear()} ProjeX. All rights
                reserved. · Version {process.env.REACT_APP_RELEASE_VERSION}
              </span>
            </div>)}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
